import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'
import { createTableSelector } from '../../../table/state/selector'
import { VOUCHER_TABLE } from './type'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectVoucherCode = (state) => {
    return selectOwnState(state).voucherCode
}

export const tableSelectorVoucher = createTableSelector(selectOwnState, VOUCHER_TABLE)



// WEBPACK FOOTER //
// ./src/modules/voucher/state/search/selector.js